import { COMMON_SET_STATE } from '../actions/types';

export interface ICommonState {
  locale: string;
  loading: boolean;
  menus: any;
  closeModal: boolean;
}

const initialState = {
  locale: 'vi',
  loading: false,
  menus: [],
  closeModal: true
};
export const commonReducer = (state = initialState, action: any): ICommonState => {
  switch (action.type) {
    case COMMON_SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
export default commonReducer;
